namespace GeniuzPOS.Purchase {
    export class PoPo06PendingCNforCnrtvColumns {
        static columnsKey = 'Purchase.PoPo06PendingCNforCnrtv';
    }
}
